import styled from 'styled-components'
// themes
import { colors } from 'themes'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 12px;
`

// A flex column with a fixed height, as the dashboard tile: the chart body fills it
export const PreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 260px;
  height: 260px;
  box-sizing: border-box;
  padding: 8px;
  border-radius: 6px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  background-color: ${colors.white100};
`

export const ScrollArea = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 16px;
  overflow-y: auto;
  padding-right: 16px;
`

export const Row = styled.div`
  display: flex;
  gap: 12px;

  > * {
    flex: 1;
    min-width: 0;
  }
`

export const Hint = styled.div`
  font-size: 13px;
  color: ${colors.gray400};
`

export const FieldHint = styled(Hint)`
  margin-top: 4px;
  font-size: 12px;
`

export const Section = styled.div`
  border-top: 1px solid ${colors.gray210};

  // Sections in a row read as one list: only their borders split them
  & + & {
    margin-top: -16px;
  }
`

export const SectionTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
`

export const SectionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
`
